import {
  medigiLanding,
  medshortsLanding,
  outsourcingLanding,
} from 'src/app/shared/models/landing';
import { defaultSupplierConfig } from 'src/environments/hydra/configs';
import { hydraSupplierConfigMap } from 'src/environments/hydra/config.map';

const supplierConfig =
  window.location.host in hydraSupplierConfigMap
    ? hydraSupplierConfigMap[window.location.host]
    : defaultSupplierConfig;

const baseURL = 'https://hikma-demo-api.medigi.com';

export const environment = {
  production: false,
  env_name: 'dev',
  domain: 'hikma-demo.medigi.com',
  url: 'https://hikma-demo.medigi.com',
  api_url_v1: baseURL,
  api_url_v2: baseURL,
  singleton_service_url: 'https://default-demo-api.medigi.com',
  medshorts_url: 'https://staging.medshorts.com',
  flower_url: 'http://localhost:8081/misc/flower/dashboard',
  health_url: 'http://localhost:8081/misc/health',
  auth_url: `${baseURL}/auth`,
  auth_url_login: `${baseURL}/auth/login`,
  proxy_url: 'http://localhost:8081/misc/proxy',
  express222Form: 'asdf',
  gatag: undefined,
  clientDomains: {
    outsourcingDomian: 'hikma-demo-503b.medigi.com',
    medigiDomain: 'hikma-demo.medigi.com',
    medshortsDomain: 'hikma-demo-medshorts.medigi.com',
    cgtDomain: '',
  },
  availableThemes: {
    'hikma-demo.medigi.com': medigiLanding,
    'hikma-demo-medshorts.medigi.com': medshortsLanding,
    'hikma-demo-503b.medigi.com': outsourcingLanding,
  },
  catalogType: {
    'hikma-demo.medigi.com': 'medigi',
    'hikma-demo-medshorts.medigi.com': 'medshorts',
    'hikma-demo-503b.medigi.com': '503b',
  },
  hydraEnabled: true,
  customLogoutURL: undefined,
  auth0: {
    clientId: 'Pdw6cXvPzpJjCTIFlaeNFiw6n3Lp26hl',
    domain: 'hydralower.us.auth0.com',
    apiIdentifier: 'https://hydralower.us.auth0.com/api/v2/',
    appMetadata: 'http://hydralower.com/api/app_metadata',
    userMetadata: 'http://hydralower.com/api/user_metadata',
    supplierHostMap: {},
  },
  sentry: {
    dsn: undefined,
  },
  legisym_url: 'https://demo.dev.express222.com/prompt.php',
  supplierConfig: supplierConfig,
};
